import React from "react";

import classes from "./header.module.css";

const Header = () => {
  return (
    <header className={classes.root}>
      <div className={classes.right}></div>
    </header>
  );
};

export default Header;
